import { render, staticRenderFns } from "./warehousing.vue?vue&type=template&id=a4faf0e6&scoped=true&"
import script from "./warehousing.vue?vue&type=script&lang=js&"
export * from "./warehousing.vue?vue&type=script&lang=js&"
import style0 from "./warehousing.vue?vue&type=style&index=0&id=a4faf0e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4faf0e6",
  null
  
)

export default component.exports